export const heroOne = {
	reverse: true,
	inverse: true,
	topLine: {
		text: 'Započeto u 2012',
	},
	headline: "Brza i pouzdana dostava",
	description: 'Gdje god bili smo osmislili dostavne solucije za vas',
	buttonLabel: 'Naruči',
	imgStart: 'start',
	img: './assets/customerservicing.png',
	linkTo: '/more',
	start: 'true',
};

export const heroTwo = {
	reverse: false,
	inverse: false,
	topLine: {
		text: 'Dizajnirano i razvijano',
	},
	headline:  'Vaše mišljenje nam puno znači',
	description: 'Naši klijenti imali su super vrijeme surađivajući s nama',
	buttonLabel: 'Vidi blog',

	linkTo: '/more',
	imgStart: 'start',
	img: './assets/customer-service.png',
	start: 'true',
};

export const heroThree = {
	reverse: true,
	inverse: true,
	topLine: {
		text: 'Visoko reputabilan brend',
	},
	headline:  'Uslužan obrt',
	description:
		'22 godine iskustva donijele su nam mogućnosti kvalitetne usluge i metodologije',
	buttonLabel: 'Pošaljite nam feedback',

	linkTo: '/download',
	imgStart: '',
	img: './assets/rating.png',
	start: 'true',
};
